import { AbstractControl, AsyncValidatorFn } from '@angular/forms';
import { debounceTime, first, map, switchMap } from 'rxjs/operators';
import { ClubsService } from '../../services/clubs/clubs.service';

export function clubNameExistsValidator(clubsService: ClubsService): AsyncValidatorFn {
    return (control: AbstractControl) => {
        return control.valueChanges.pipe(
            debounceTime(500),
            switchMap((value) => clubsService.clubNameExists(value)),
            map((exists) => {
                if (exists) {
                    return { uniqueClubName: true };
                }
                return null;
            }),
            first(),
        );
    };
}
